<template>
  <div class="root" :style="{ width: `${visibleBodyParts.length * 21 + 1}px` }">
    <div
      v-for="part in visibleBodyParts"
      :key="part.name"
      class="image-wrapper"
    >
      <body-part-image
        :part="part"
        :class="`image ${part.active ? 'bg-green' : 'bg-light2'}`"
        v-b-tooltip.hover="$t(`bodypart_${part.name}`)"
      />
    </div>
  </div>
</template>

<script>
import BodyPartImage from '@/elements/BodyPartImage';
import config from '@/config';

export default {
  name: 'BodyParts',
  props: {
    showInactive: {
      default: false,
    },
    parts: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  components: {
    BodyPartImage,
  },
  computed: {
    visibleBodyParts() {
      if (this.showInactive) {
        return config.availableBodyParts.map(part => ({
          name: part,
          active: (this.parts || []).includes(part),
        }));
      }

      return (this.parts || []).map(part => ({ name: part, active: true }));
    },
  },
};
</script>

<style scoped lang="scss">
.root {
  display: inline-block;
}

.image {
  height: 20px;
  width: 20px;
  line-height: 22px;
}

.image-wrapper {
  display: inline-block;

  &:not(:last-child) {
    margin-right: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/elements/BodyParts.vue